module.exports = __webpack_public_path__ + "img/antes_despues_235.26ca6cef.png";